<template>
  <div class="dsf-database">
    <form action="" @submit.stop.prevent="search">
      <el-input v-model="keywords" class="database-search-input">
        <div class="button" slot="append" @click="search">
          <i class="iconfont icon-fangdajing"></i>
        </div>
      </el-input>
    </form>
    <div class="db-item" v-for="tab in tempData" :key="tab.name">
      <h3 class="title">{{ tab.title }}</h3>
      <ul class="item-content">
        <template v-for="it in tab.tabItems">
          <li @click="openUrl(it.urlAddress)" :Key="it.name" v-show="it.show">
            <div class="img-wrap">
              <dsfImage :src="it.imgUrl" :dUrl="it.imgUrl" :height="'100%'" />
            </div>
            <div class="name">{{ it.name }}</div>
          </li>
        </template>
        <template v-if="!tab.tabItems.length"><dsf-empty-data text="暂无数据" /></template>
      </ul>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfRegisterDatabase",
  ctrlCaption: "注册数据资源面板",
  mixins: [$mixins.control, $mixins.card],
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    // keysMap: {
    //   type: Array,
    //   default() {
    //     return [
    //       { from: "title", to: "title", type: "text", desc: "标题" },
    //       { from: "name", to: "name", type: "text", desc: "资源名称" },
    //       { from: "urlAddress", to: "urlAddress", type: "text", desc: "跳转地址" },
    //       { from: "imgUrl", to: "imgUrl", type: "text", desc: "图片地址" },
    //     ];
    //   },
    // },
    name: {
      type: String,
      default: "",
    },
    useInterface: {
      type: Boolean,
      default: false,
    },
    sourceUrl: {
      type: String,
      default: "/resourceType/getTree",
    },
    refeshParent: {
      type: Boolean,
      default: true,
    },
    closedialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      keywords: "",
      tempData: [],
      list: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      if (!this.isDesign && this.useInterface) {
        this.initDatabase();
      } else {
        this.initData();
      }
    },
    initData() {
      let list = _.cloneDeep(this.tabList);
      list = list.map(item => {
        item.tabItems.map(it => {
          it.show = true;
          return it;
        });
        return item;
      });
      this.tempData = list;
    },
    filterData(reg) {
      const data = this.tempData.filter(item => {
        item.tabItems.filter(it => {
          if (!it["name"].match(reg)) {
            it.show = false;
          } else {
            it.show = true;
          }
        });
        return item;
      });
      return data;
    },
    search() {
      if (!this.useInterface) {
        if (this.keywords.trim() != "") {
          //如果不是使用接口 前端过滤自己处理
          const reg = new RegExp(this.keywords.toLowerCase());
          const data = this.filterData(reg);
          this.tempData = data;
        } else {
          this.tempData = this.tempData.filter(item => {
            item.tabItems.filter(it => {
              it.show = true;
            });
            return item;
          });
        }
      } else {
        this.initDatabase();
      }
    },
    reloadData() {
      this.init();
      this.reloadParent();
    },
    reloadParent() {
      if (this.refeshParent) {
        const pvm = this.$dialog?.options?.params?.vm;
        pvm.$refs?.datagrid1?.reloadData();
      }
    },
    openUrl(path) {
      if (!path) {
        dsf.layer.message('路径不存在', false);
        return;
      }
      let vm = this;
      if (vm.$vm) {
        vm = vm.$vm;
        if (vm.$openerVm) {
          vm = vm.$openerVm;
        }
      }
      vm.$openWindow(this.$replace(path));
      this.$dialog?.close();
    },
    initDatabase() {
      const loading = dsf.layer.pc.loading();
      const params = { name: this.keywords };
      this.$http
        .get(this.sourceUrl, params)
        .done(({ success, data }) => {
          if (success) {
            this.setDatabase(data);
          } else {
            dsf.layer.message("查询注册数据资源失败", false);
          }
        })
        .error(() => {
          dsf.layer.message("查询注册数据资源失败", false);
        })
        .always(() => {
          dsf.layer.pc.closeLoading(loading);
        });
    },
    setDatabase(data) {
      let list = data.map(item => {
        return {
          title: item.resName,
          tabItems: item.children.map(it => {
            const { resName, iconAddress, url } = it;
            return {
              name: resName,
              urlAddress: url,
              imgUrl: iconAddress,
              show: true,
            };
          }),
        };
      });
      this.tempData = list;
    },
  },
});
</script>
<style lang="scss">
 @import "_platform/assets/styles/pc/bhc/other/registerDatabase.scss";
</style>